export const COHORT_WRITE_MUTATION_KEY = 'cohort-write' as const;
